import api from '../../../utils/api';

/**
 * Hunt Sign-Out Service
 * Handles all hunt location sign-out and sign-in operations
 */
export class HuntSignOutService {
  /**
   * Sign out a hunt location
   */
  static async signOutLocation(locationId, userId, date, timePeriod) {
    try {
      const response = await api.post(`/hunt-locations/${locationId}/sign_out/`, {
        date,
        time_period: timePeriod,
        user_id: parseInt(userId, 10)
      });
      console.log('Location signed out successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to sign out location:', error);
      throw error;
    }
  }

  /**
   * Sign in (release) a location.
   * @param {number|string} locationId
   * @param {string} date YYYY-MM-DD
   * @param {string} timePeriod morning|midday|afternoon
   * @param {{ userId?: number|string|null, requireRemoved?: boolean }} [options]
   *   userId — when president clears another hunter's stand (backend optional user_id)
   *   requireRemoved — throw if API reports no matching sign-out (avoids fake success)
   */
  static async signInLocation(locationId, date, timePeriod, options = {}) {
    const { userId = null, requireRemoved = false } = options;
    try {
      const payload = {
        date,
        time_period: String(timePeriod).toLowerCase(),
      };
      if (userId != null && userId !== '') {
        payload.user_id = parseInt(userId, 10);
      }
      const response = await api.post(`/hunt-locations/${locationId}/sign_in/`, payload);
      const data = response.data || {};
      const noMatch =
        typeof data.message === 'string' &&
        /no matching sign-out/i.test(data.message);
      if (requireRemoved && (noMatch || data.removed === 0)) {
        const err = new Error(
          'Could not clear stand — no matching tag-in found for that hunter/sit.'
        );
        err.response = { data };
        throw err;
      }
      console.log('Location signed in successfully:', data);
      return data;
    } catch (error) {
      console.error('Failed to sign in location:', error);
      throw error;
    }
  }

  /**
   * Check if a location is available for a specific date
   */
  static isLocationAvailable(location, date) {
    if (!location.sign_out_records || location.sign_out_records.length === 0) {
      return true;
    }
    
    const hasSignOutToday = location.sign_out_records.some(record => record.date === date);
    return !hasSignOutToday;
  }

  /**
   * Get today's sign-out details for a location
   */
  static getTodaySignOutDetails(location) {
    if (!location.sign_out_records || location.sign_out_records.length === 0) {
      return null;
    }
    
    // Compare using local-safe YMD
    // Dynamic import to avoid eager module costs in some tests
    // eslint-disable-next-line global-require
    const { toLocalYMD } = require('../../../utils/dateUtils');
    const today = toLocalYMD(new Date());
    return location.sign_out_records.find(record => record.date === today);
  }
}
